export default __webpack_public_path__ + "static/media/car-service-header.b99d1ad4.jpg";